import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environments/environment';
import { ProcessLog } from 'src/app/user-identification/models/user-identification';
import { CloudLogsService, LogType } from './cloud-logs.service';

/** Cooldown entre intentos de POST para no saturar el back ante ráfagas de errores. */
const NOTIFY_COOLDOWN_MS = 3 * 60 * 1000;

@Injectable({
	providedIn: 'root',
})
export class MediaServerRestartService extends ApiService {
	private cloudLogsService = inject(CloudLogsService);

	private inFlight = false;
	private lastRequestAt = 0;

	constructor() {
		super();
	}

	/**
	 * Notifica al back un fallo de streaming.
	 * El back aplica cooldown global (Cache) y decide si ejecuta el reinicio SSH.
	 * Rate limit cliente: una petición en vuelo y cooldown entre intentos (por pestaña).
	 * @param reason Motivo técnico opcional (p. ej. webrtc_init_failed:...) para trazabilidad en logs.
	 */
	public notifyMediaServerFailure(reason?: string): void {
		const now = Date.now();
		if (this.inFlight) return;
		if (this.lastRequestAt > 0 && now - this.lastRequestAt < NOTIFY_COOLDOWN_MS) return;

		this.inFlight = true;
		this.lastRequestAt = now;

		const reasonSuffix = reason ? ` reason=${reason}` : '';

		this.http
			.post<void>(`${environment.identity2}/media-server/restart`, null, { headers: this.getHeaders() })
			.pipe(finalize(() => (this.inFlight = false)))
			.subscribe({
				error: (error: HttpErrorResponse) => {
					this.cloudLogsService.sendCloudLogs(
						{
							media_server_restart: `media-server/restart failed: ${error?.message ?? error?.status}${reasonSuffix}`,
						},
						ProcessLog.IN_PROCESS,
						LogType.Error,
					);
				},
			});
	}
}
